var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 40C80 50.8988 75.6412 60.7795 68.5717 67.994C67.2527 57.8481 62.8876 49.3036 55.4766 44.5298C55.2701 44.3912 55.0242 44.3237 54.776 44.3375C54.5277 44.3512 54.2908 44.4454 54.1008 44.6059C50.1654 47.514 45.3937 49.0688 40.5005 49.0376C35.6127 49.033 30.8518 47.482 26.8992 44.6068C26.8136 44.5454 26.7212 44.4952 26.6243 44.4568C26.4966 44.4062 26.361 44.3762 26.2224 44.3685C25.9786 44.355 25.7362 44.4113 25.5234 44.5307C17.9019 49.4418 13.4988 58.3453 12.3219 68.8778C4.72791 61.5974 0 51.3508 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM57.5399 26.0394C57.5399 35.45 49.911 43.0788 40.5005 43.0788C31.0898 43.0788 23.4611 35.45 23.4611 26.0394C23.4611 16.6288 31.0898 9 40.5005 9C49.911 9 57.5399 16.6288 57.5399 26.0394Z",
    fill: "#A0A0A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericUserAvatar);
export default __webpack_public_path__ + "static/media/generic-user-avatar.3a1d4321ec7a2c31296e9347ef6f83bf.svg";
export { ForwardRef as ReactComponent };